module.exports = __webpack_public_path__ + "static/img/qr4.5ea45a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr4.png
// module id = rZBz
// module chunks = 1